export default "__VITE_ASSET__BDljXq____"